import { useFormikContext } from "formik";
import { FC, useEffect } from "react";
import { IIsAuthorizedSignature } from "../../../../interfaces/Contact";
import { customerTypeEnum } from "../../../../utils";
import { CheckboxInput } from "../../../../components";
import useLocales from "../../../../hooks/useLocales";

const IsAuthorizedSignature: FC<IIsAuthorizedSignature> = ({
  name,
  customerTypeId,
  customerKindId,
}) => {
  const { translate } = useLocales();
  const { values, setFieldValue }: any = useFormikContext();

  /* useEffect(() => {
    if (Number(customerTypeId) === customerTypeEnum.real) {
      setFieldValue("isAuthorizedSignature", true);
      setFieldValue("isAuthorizedPerson", true);
    } else {
      setFieldValue("isAuthorizedSignature", false);
      setFieldValue("isAuthorizedPerson", false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerTypeId, customerKindId]); */

  return (
    <CheckboxInput
      name={name}
      label={translate(
        "resources.customers.related_persons.isAuthorizedSignature"
      )}
      disabled={values.isExistCustomer}
    />
  );
};

export default IsAuthorizedSignature;
